// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nlp-designer__buttons-node {
    border: 2px solid #aaa;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    cursor: pointer;
}

.nlp-designer__buttons-node-buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0px 24px 16px;
}

.nlp-designer__buttons-node-label {
    font-weight: bold;
    text-transform: capitalize;
    font-size: 24px;
    border-bottom: 1px solid #aaa;
    padding: 8px 24px;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlpDesigner/components/buttonsNode/ButtonsNode.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB","sourcesContent":[".nlp-designer__buttons-node {\r\n    border: 2px solid #aaa;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.nlp-designer__buttons-node-buttons {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    padding: 0px 24px 16px;\r\n}\r\n\r\n.nlp-designer__buttons-node-label {\r\n    font-weight: bold;\r\n    text-transform: capitalize;\r\n    font-size: 24px;\r\n    border-bottom: 1px solid #aaa;\r\n    padding: 8px 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
